import React, { PureComponent } from 'react';
import style from './styles/style.module.css';

export default class TableHead extends PureComponent {
    render() {
        const { children } = this.props;
        const className = `dl-table-head ${ style.tableHead } ${ this.props.className }`;
        return (
            <div className={ className } id={ this.props.id }>
                { children }
            </div>
        );
    }
}
TableHead.defaultProps = {
    className: '',
};
